angular.module('impactx.accountassignmenttype').controller('AccountAssignmentTypeController', AccountAssignmentTypeController);
AccountAssignmentTypeController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$routeParams',
    'ToolbarService',
    'WarningService'
];

function AccountAssignmentTypeController($scope, dataGen, BackService, $mdToast, ConfirmationService, $routeParams, ToolbarService, WarningService) {
    var ctrl = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/accountassignmenttype/view").then(function () {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    });

    this.save = function ($event) {
        var warnings = ctrl.checkWarnings();
        if (warnings.length === 0) {
            return ctrl.saveFinal();
        }
        else {
            WarningService.showWarningDialog(ctrl.saveFinal, $event, $scope.trns.warning, $scope.trns.saveAnyway,
                $scope.trns.abort, warnings);
        }
    };

    this.checkWarnings = function () {
        var warnings = [];
        if ($scope.data.companyRelations.relation.assigned.length === 0) {
            warnings.push($scope.trns.noRelationsWarning)
        }
        return warnings;
    };

    this.saveFinal = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/accountassignmenttype/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.getData($scope, dataObj, "/accountassignmenttype/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.onEnableChange = function (setting) {
        if (!setting.enabled.value) {
            setting.required.selected = setting.required.entries[0];
        }
    };

    ctrl.getCtrlInputParams = function () {
        var comIds = [];
        var assigned = $scope.data.companyRelations.relation.assigned;
        for (var i = 0; i < assigned.length; i++) {
            comIds.push(assigned[i].id);
        }
        return [
            {field: 'comIds', value: comIds}
        ];
    };

    function canDelete() {
        return impactX.isDefined($scope, 'data.id') > 0;
    }
}